export class CostReviewExhaustFans {
  numberOfExhaustFans!: number;
  manufacturer!: string;
  unitsControlsFurnishedBy!: number;
  unitsControlsInstalledBy!: number;
  unitsControlsWiredBy!: number;
  isExhaustFansApplicable!: boolean;
}
